<template>
  <div id="professionalCareerObjectiveDetailTab">
    <v-card>
      <v-card-title>
        Add Job Preferences <small v-if="jobPreferences.length === 0" class="ml-2 text-error">*</small>
        <small v-if="jobPreferences.length === 0" class="ml-2 text-error">One Job Preference is required</small>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12"
            ><InfoBox
              title="Tell us what your Job Preferences are, including your preferred roles, working arrangements and rates. This will help us match your profile with the roles that best suit your skills and needs."
          /></v-col>
          <v-col cols="12">
            <v-btn class="primary_btn w-100" prepend-icon="mdi-plus" @click="showAddJobPreferences = true"> Add Job Preferences</v-btn>
          </v-col>
        </v-row>

        <v-row class="mt-5">
          <v-col cols="12" md="6" v-for="(item, index) in jobPreferences" :key="index">
            <JobPreferencesItem
              :jobPreferences="item"
              :jobTitles="jobTitles"
              :loading="loading"
              :isHiringmanager="isHiringmanager"
              @edit="edit(item, index)"
              @remove="remove(item, index)"
            />
            <!-- <v-data-table :hide-default-footer="true" :items="careerObjectives" :headers="headers" :loading="loading">
                <template v-slot:item.WorkingPosition="{ item }">
                  {{ getJobName(item.WorkingPosition) }}
                </template>
                <template v-slot:item.PreferredLocation="{ item }">
                  {{ item.PreferredLocation ? getStringOfArray(item.PreferredLocation) : "-" }}
                </template>
                <template v-slot:item.EmploymentType="{ item }">
                  {{ getStringOfArray(item.EmploymentType) }}
                </template>
                <template v-slot:item.Amount="{ item }">
                  {{ item.IsNegotiable ? "Negotiable" : item.Amount }}
                </template>
                <template v-slot:item.Actions="{ index, item }">
                  <div>
                    <v-btn
                      v-if="!isHiringmanager"
                      class="secondary mt-1 mb-1 mr-3"
                      :disabled="loading"
                      fab
                      x-small
                      title="Edit"
                      @click="edit(item, index)"
                      ><v-icon>mdi-circle-edit-outline</v-icon></v-btn
                    >
                    <v-btn v-if="!isHiringmanager" class="error mt-1 mb-1" :disabled="loading" fab x-small title="Delete" @click="remove(item, index)"
                      ><v-icon>mdi-delete</v-icon></v-btn
                    >
                  </div>
                </template>
              </v-data-table> -->
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-dialog persistent @keydown.esc="showAddJobPreferences = false" v-model="showAddJobPreferences" max-width="1000px">
      <v-card>
        <v-card-title> Add Job Preferences </v-card-title>
        <v-card-text>
          <v-form ref="frmMain" lazy-validation>
            <v-row>
              <v-col cols="12"
                ><InfoBox
                  title="Tell us what your Job Preferences are, including your preferred roles, working arrangements and rates. This will help us match your profile with the roles that best suit your skills and needs."
              /></v-col>
              <v-col cols="12">
                <span class="f-body-1">What Position Would You Like to Work In?</span>
              </v-col>
              <v-col cols="12" md="6" lg="4">
                <AutoCompleteField
                  :readonly="isHiringmanager"
                  outlined
                  :items="jobTitles"
                  item-title="Name"
                  item-value="id"
                  :rules="[validations.required, validations.arrayMinLength(1)]"
                  hint="Your skills will be assessed based on the job interest you select."
                  placeholder="Position"
                  v-model="jobPreferencesModel.WorkingPosition"
                  dense
                />
              </v-col>
              <v-col cols="12" md="6" lg="4">
                <AutoCompleteField
                  :readonly="isHiringmanager"
                  dense
                  outlined
                  :items="seniorityLevels"
                  :rules="[validations.required]"
                  placeholder="Seniority Level"
                  showRequired
                  v-model="jobPreferencesModel.SeiorityLevel"
                />
              </v-col>
              <v-col cols="12" md="6" lg="4">
                <AutoCompleteField
                  placeholder="Years of experience"
                  dense
                  outlined
                  :items="experienceYears"
                  :rules="[validations.required]"
                  v-model="jobPreferencesModel.PositionExperienceYear"
                />
              </v-col>
              <v-col cols="12">
                <span class="f-body-1">What Type of Employment are you most interested in?</span>
              </v-col>
              <v-col cols="12" md="6" lg="4">
                <AutoCompleteField
                  :readonly="isHiringmanager"
                  dense
                  outlined
                  :items="employmentTypes"
                  multiple
                  deletable-chips
                  chips
                  :rules="[validations.required, validations.arrayMinLength(1)]"
                  placeholder="Type Of Employment"
                  v-model="jobPreferencesModel.EmploymentType"
                />
              </v-col>
              <v-col cols="12" md="6" lg="4">
                <AutoCompleteField
                  :readonly="isHiringmanager"
                  dense
                  outlined
                  :items="locationTypes"
                  placeholder="On-Site/Remote"
                  v-model="jobPreferencesModel.PreferredLocation"
                  multiple
                  deletable-chips
                  chips
                />
              </v-col>
              <v-col cols="12">
                <span class="f-body-1">What is your salary expectation?</span>
              </v-col>
              <v-col cols="12" md="6" lg="4">
                <NumberField
                  :readonly="isHiringmanager"
                  :min="0"
                  :disabled="jobPreferencesModel.IsNegotiable"
                  dense
                  v-model="jobPreferencesModel.Amount"
                  outlined
                  placeholder="Salary Expectation"
                />
              </v-col>
              <v-col cols="12" md="6" lg="4">
                <AutoCompleteField
                  :readonly="isHiringmanager"
                  disabled
                  dense
                  v-model="jobPreferencesModel.Currency"
                  outlined
                  placeholder="Currency"
                />
              </v-col>
              <v-col cols="12" md="6" lg="4">
                <v-switch
                  :readonly="isHiringmanager"
                  label="Not Specified / Negotiable"
                  class="negotiable"
                  v-model="jobPreferencesModel.IsNegotiable"
                />
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn @click="cancel()" class="secondary_btn mr-5" :loading="loading" prepend-icon="mdi-cancel"> Cancel</v-btn>
          <v-btn class="primary_btn" @click="submitForm()" :loading="loading" prepend-icon="mdi-plus">
            {{ jobPreferencesModel.Id == "" && selectedItemIndexForEdit == null ? "Add Job Preference" : "Save Job Preference" }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog persistent v-model="showRemoveConfirm" @keydown.esc="showRemoveConfirm = false" max-width="400px">
      <confirm-dialog @confirm="confirmDelete" @cancel="showRemoveConfirm = false" :message="confirmModel"> </confirm-dialog>
    </v-dialog>
  </div>
</template>
<script lang="ts">
import { defineComponent } from "vue";
import { JobPreferencesModel } from "../../models/Teammember";
import { Profile } from "../../definitions/config";
import validations from "../../utils/validations";
import Details from "../../models/Details";
import ConfirmDialog from "../ConfirmDialog.vue";
import { ProjectMessages } from "../../definitions/constants";
import AutoCompleteField from "../Fields/AutoCompleteField.vue";
import TextField from "../Fields/TextField.vue";
import PositionYear from "./PositionYear.vue";
import JobPreferencesItem from "./JobPreferencesItem.vue";
import InfoBox from "../InfoBox.vue";

export default defineComponent({
  props: ["loading", "jobTitles", "jobPreferencesList", "showRequiredError", "showRequired", "isHiringmanager"],
  components: {
    ConfirmDialog,
    TextField,
    AutoCompleteField,
    PositionYear,
    InfoBox,
    JobPreferencesItem,
  },
  data() {
    return {
      isEditting: false,
      positionName: "",
      jobPreferences: [] as JobPreferencesModel[],
      validations,
      jobRoles: [] as Details[],
      showPositionYear: false,
      shouldRequest: true,
      selectedJobRoles: null as string[] | null,
      showSaveForLaterConfirm: false,
      selectedJobTitle: "",
      experienceYears: Profile.Members.SkillExperienceList,
      selectedExperienceYear: null as string | null,
      seniorityLevels: Profile.Members.ProfessionalDetailLevel,
      locationTypes: Profile.Members.LocationTypes,
      filteredJobTitles: [] as string[],
      employmentTypes: Profile.Members.EmploymentTypes,
      salaryExpectations: 0,
      selectedItemIndexForDelete: null as number | null,
      confirmModel: {
        title: ProjectMessages.removeJobPreferences,
        text: ProjectMessages.confirmation,
      },
      showRemoveConfirm: false,
      showAddJobPreferences: false,
      jobPreferencesModel: {
        Amount: 0,
        EmploymentType: null,
        Id: null,
        IsNegotiable: false,
        PositionExperienceYear: null,
        PreferredLocation: null,
        SeiorityLevel: null,
        WorkingPosition: null,
        Currency: "AUD",
      } as JobPreferencesModel,
      selectedItemIndexForEdit: null as number | null,
      headers: [
        { sortable: false, title: "Working Position", value: "WorkingPosition" },
        { sortable: false, title: "Experience", value: "PositionExperienceYear", align: "center" },
        { sortable: false, title: "Preferred Location", value: "PreferredLocation", align: "center" },
        { sortable: false, title: "Seniority Level", value: "SeiorityLevel", align: "center" },
        { sortable: false, title: "Employment Type", value: "EmploymentType", align: "center" },
        { sortable: false, title: "Amount", value: "Amount", align: "center" },
        { sortable: false, title: "Actions", value: "Actions" },
      ],
      selectedItemForDelete: null,
    };
  },
  methods: {
    cancelPsitionYear() {
      this.showPositionYear = false;
    },
    edit(item: any, index: number) {
      this.isEditting = true;
      if (!item.Id) {
        this.selectedItemIndexForEdit = index;
      } else {
        this.selectedItemIndexForEdit = null;
      }
      this.jobPreferencesModel = { ...item };
      this.jobPreferencesModel.Currency = "AUD";
      this.showAddJobPreferences = true;
    },
    remove(item: any, index: any) {
      if (!item.Id) {
        this.selectedItemIndexForDelete = index;
      } else {
        this.selectedItemForDelete = item.Id;
        this.selectedItemIndexForDelete = null;
      }
      this.confirmModel.text = `Are you sure you want to delete ${this.getJobName(item.WorkingPosition)} job preference?`;
      this.showRemoveConfirm = true;
    },
    confirmDelete() {
      if (this.selectedItemForDelete || this.selectedItemIndexForDelete != null) {
        this.showRemoveConfirm = false;
        this.$emit("removeJobPreferences", {
          props: {
            id: this.selectedItemForDelete,
            index: this.selectedItemIndexForDelete,
          },
          callbackMethod: () => {
            this.jobPreferences = [...this.jobPreferencesList];
          },
        });
        this.selectedItemForDelete = null;
        this.selectedItemIndexForDelete = null;
      }
    },
    cancel(): void {
      this.resetForm();
      this.showAddJobPreferences = false;
    },
    scrollToElement(el: any) {
      this.$emit("scrollToElement", el);
    },
    getJobName(id: any) {
      var findJobTitle = this.jobTitles.find((item: any) => item.id == id);
      if (findJobTitle) {
        return findJobTitle.Name;
      }
    },
    getStringOfArray(array: string[]) {
      return array.join(", ");
    },
    async submitForm() {
      const isValid = (await (this.$refs.frmMain as any).validate()).valid;
      if (isValid) {
        this.save();
      } else {
        var el = document.querySelector("#professionalCareerObjectiveDetailTab .v-messages.error--text:first-of-type");
        this.scrollToElement(el);
      }
    },
    save() {
      if (this.jobPreferencesModel.IsNegotiable == null) {
        this.jobPreferencesModel.IsNegotiable = false;
      }
      this.$emit("SaveJobPreferences", {
        props: {
          model: this.jobPreferencesModel,
          index: this.selectedItemIndexForEdit,
        },
        callbackMethod: () => {
          if (this.jobPreferencesList) {
            this.jobPreferences = [...this.jobPreferencesList];
          }
          this.resetForm();
        },
      });
      this.showAddJobPreferences = false;
    },
    resetForm() {
      this.selectedItemIndexForEdit = null;
      this.jobPreferencesModel = {
        Amount: 0,
        EmploymentType: null,
        Id: "",
        IsNegotiable: false,
        PositionExperienceYear: null,
        PreferredLocation: null,
        SeiorityLevel: null,
        WorkingPosition: null,
        Currency: "AUD",
      };
    },
  },
  mounted() {
    this.jobPreferences = this.jobPreferencesList;
  },
  watch: {
    jobPreferencesList(newVal) {
      this.jobPreferences = [...newVal];
    },
    "jobPreferencesModel.WorkingPosition"(newVal: any) {
      if (!this.isEditting) {
        this.jobPreferencesModel.PositionExperienceYear = null;
        var position = this.jobTitles.find((c: any) => c.id === newVal);
        if (position) {
          this.positionName = position.Name;
          this.showPositionYear = true;
        }
      }
      this.isEditting = false;
    },
    "jobPreferencesModel.IsNegotiable"(newVal) {
      if (newVal) {
        if (this.jobPreferencesModel) {
          this.jobPreferencesModel.Amount = 0;
        }
      }
    },
  },
});
</script>
<style lang="scss">
.negotiable {
  .v-label {
    font-size: 16px !important;
  }
}
</style>
